import {
  hideErrorNotifications,
  showErrorNotification,
  showGenericErrorNotification,
  hideGenericErrorNotifications,
  catchReauthError,
} from './actions';

import { ErrorsState } from './types';
import { createReducer } from 'typesafe-actions';
import { combineReducers } from 'redux';
import { v4 } from 'uuid';

export const initialState: ErrorsState = {
  genericErrors: [],
  errors: [],
  isReauthRequired: false,
};

const errors = createReducer(initialState.errors)
  .handleAction(showErrorNotification, (state, action) => [...state, { uuid: v4(), ...action.payload }])
  .handleAction(hideErrorNotifications, () => []);

const genericErrors = createReducer(initialState.genericErrors)
  .handleAction(showGenericErrorNotification, (state, action) => [...state, { uuid: v4(), ...action.payload }])
  .handleAction(hideGenericErrorNotifications, () => []);

const isReauthRequired = createReducer(initialState.isReauthRequired).handleAction(catchReauthError, () => true);

export default combineReducers({ errors, genericErrors, isReauthRequired });
